export const LOGIN_LINK_SOURCE = 'loginLink';
